// src/components/wizard/WizardRefinement.jsx
import React from 'react';
import styles from './WizardStep.module.css';

const OPTIONS = [
  { value:'no-referral',    icon:'🚪', label:'Something I can access right away',       desc:'No referral needed, available now' },
  { value:'free',           icon:'🤲', label:'Programs that are free',                  desc:'No cost to access' },
  { value:'family-access',  icon:'👪', label:'Programs my family can access directly',  desc:'Without needing the Veteran to be involved' },
  { value:'virtual',        icon:'💻', label:'Available online or by phone',            desc:'Virtual or remote access' },
  { value:'any',            icon:'🔍', label:'Show me everything relevant',             desc:"I'll filter from there" },
];

export default function WizardRefinement({ selected, onSelect, onBack, onSkip }) {
  return (
    <div className={styles.stepWrap}>
      <p className={styles.eyebrow}>One last thing</p>
      <h1 className={styles.title}>What would be most<br /><em>helpful right now?</em></h1>
      <p className={styles.subSm}>Selecting one of these takes you straight to your results.</p>

      <div className={styles.refineGrid}>
        {OPTIONS.map(o => (
          <button
            key={o.value}
            className={`${styles.refineCard} ${selected === o.value ? styles.selected : ''}`}
            onClick={() => onSelect(o.value)}
          >
            <span className={styles.refineIcon}>{o.icon}</span>
            <div>
              <div className={styles.refineLabel}>{o.label}</div>
              <div className={styles.refineDesc}>{o.desc}</div>
            </div>
          </button>
        ))}
      </div>

      <div className={styles.btnRow}>
        <button className={styles.btnBack} onClick={onBack}>← Back</button>
        <button className={styles.btnText} onClick={onSkip}>Skip — show me everything</button>
      </div>
    </div>
  );
}
